import { useState, useCallback } from "react";
import { Input } from "antd";
import { useForm } from "@formily/react";
import CaptchaCode from "react-captcha-code";

function Captcha({ value, onChange, ...props }) {
  const [code, setCode] = useState();
  const form = useForm();
  const changeHandler = useCallback(
    (e) => {
      const v = e.target.value;
      onChange(v);

      if (code !== v) {
        form.setFieldState("captcha", { selfErrors: ["验证码不正确"] });
      } else {
        form.clearErrors("captcha");
      }
    },
    [code, form, onChange]
  );

  return (
    <div
      style={{ display: "inline-flex", width: "100%", alignItems: "center" }}
    >
      <Input
        {...props}
        style={{ marginRight: 5, ...props.style }}
        value={value}
        onChange={changeHandler}
      />
      <div
        style={{
          color: "#999",
          width: 100,
          height: 35,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CaptchaCode
          charNum={4}
          onChange={(code) => {
            setCode(code);
          }}
        />
      </div>
    </div>
  );
}

export default Captcha;
